import ResourceService from "./resource.service";

class WorkFlowService extends ResourceService {
  static get resource() {
    return "workflow";
  }
}

export default WorkFlowService;